import React from "react";
function BAITable({ gender }) {
  return (
    <div style={{ overflowX: "auto" }}>
      {gender === "female" && (
        <>
          <h3>جدول مؤشر السمنة للنساء</h3>
          <table >
            <thead>
              <tr>
                <th >العمر (بالسنوات)</th>
                <th >نقص الوزن</th>
                <th >صحي</th>
                <th >زيادة الوزن</th>
                <th >سمنة</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>20 - 39</td>
                <td>أقل من 21%</td>
                <td>21% إلى 33%</td>
                <td>أكثر من 33%</td>
                <td>أكثر من 39%</td>
              </tr>
              <tr>
                <td>40 - 59</td>
                <td>أقل من 23%</td>
                <td>23% إلى 35%</td>
                <td>أكثر من 35%</td>
                <td>أكثر من 41%</td>
              </tr>
              <tr>
                <td>60 - 79</td>
                <td>أقل من 25%</td>
                <td>25% إلى 38%</td>
                <td>أكثر من 38%</td>
                <td>أكثر من 43%</td>
              </tr>
              <tr>
                <td colSpan="5">
                  <b>المصدر:</b>{" "}
                  <a href="https://pubmed.ncbi.nlm.nih.gov/22484365/">
                    منظمة الصحة العالمية
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
      {gender === "male" && (
        <>
          <h3>جدول مؤشر السمنة للرجال</h3>
          <table >
            <thead>
              <tr>
                <th >العمر (بالسنوات)</th>
                <th >نقص الوزن</th>
                <th >صحي</th>
                <th >زيادة الوزن</th>
                <th >سمنة</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>20 - 39</td>
                <td>أقل من 8%</td>
                <td>8% إلى 21%</td>
                <td>أكثر من 21%</td>
                <td>أكثر من 26%</td>
              </tr>
              <tr>
                <td>40 - 59</td>
                <td>أقل من 11%</td>
                <td>11% إلى 23%</td>
                <td>أكثر من 23%</td>
                <td>أكثر من 29%</td>
              </tr>
              <tr>
                <td>60 - 79</td>
                <td>أقل من 13%</td>
                <td>13% إلى 25%</td>
                <td>أكثر من 25%</td>
                <td>أكثر من 31%</td>
              </tr>
              <tr>
                <td colSpan="5">
                  <b>المصدر:</b>{" "}
                  <a href="https://pubmed.ncbi.nlm.nih.gov/22484365/">
                    منظمة الصحة العالمية
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
export default BAITable;
